<template>

  <article class="container-fluid" id="landing-top">

    <section class="container-fluid hero">
      <div class="container">

        <h1 id="Greeting">{{welcomeText}} {{username}}</h1>
        <h2 id="Purpose">What would you like to do today?</h2>

      </div>
      <div class="container">
        <div class="row">
          <div :class="blockClass" style="margin-bottom: 16px">
            <div class="card banner-card-block" >
              <img class="card-img-top" :src="require('@/assets/images/landReach.jpg')" alt="Increase your brand's reach to new prospects">
              <div class="card-body banner-card">
                <h5>Reach new prospects</h5>
                <p class="card-text">
                  through traditional direct mail or via a digital marketing campaign.
                </p>
              </div>
              <div style="margin-bottom: 20px">
                <b-btn  v-scroll-to="'#prospects'"  class="btn btn-outline-secondary">Tell me more</b-btn>
              </div>

            </div>

          </div>
          <div :class="blockClass" style="margin-bottom: 16px">
            <div class="card banner-card-block">
              <img class="card-img-top" :src="require('@/assets/images/landManage.jpg')" alt="Discover more facets of your customers">
              <div class="card-body banner-card">
                <h5>Manage my customer data</h5>
                <p class="card-text">
                  by verifying or by enhancing the information I have collected.
                </p>
              </div>
              <div style="margin-bottom: 20px">
                <b-btn  v-scroll-to="'#service'" class="btn btn-outline-secondary" >Tell me more</b-btn>
              </div>
            </div>
          </div>
          <div :class="blockClass" style="margin-bottom: 16px">
            <div class="card banner-card-block">
              <img class="card-img-top" :src="require('@/assets/images/landAnalyze.jpg')" alt="Learn hor your customers fit together">
              <div class="card-body banner-card">
                <h5>Analyze my customers</h5>
                <p class="card-text">
                  to discover characteristics they may share with others in my area.
                </p>
              </div>
              <div style="margin-bottom: 20px">
                <b-btn v-scroll-to="'#analyze'" class="btn btn-outline-secondary">Tell me more</b-btn>
              </div>
            </div>
          </div>
          <div :class="blockClass" :style="videoVisibleFlag">
            <div class="card banner-card-block">
              <img class="card-img-top" :src="require('@/assets/images/VideoMarketing.jpg')" alt="">
              <div class="card-body banner-card">
                <h5>Display my videos</h5>

                <p class="card-text">
                  See what else we can do for you.
                </p>
              </div>
              <div style="margin-bottom: 20px">
                <b-btn @click="gotoVideo" class="btn btn-outline-secondary">Show Me</b-btn>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="container">
        &nbsp;
      </div>

    </section>

    <section class="container">

      <div class="jumbotron">
        <h2 class="display-4" id="prospects">Reach new prospects</h2>
        <p class="lead">Connect with your best prospects through privacy-compliant digital or traditional channels to win new customers. Do it yourself or work with a specialist.</p>
        <hr class="my-4">
        <h3>Order a mailing list</h3>
        <p>Build, order and download a new list of prospects in just minutes. Add phone numbers (where available) for follow-up.</p>
        <div class="card-deck">
          <div class="card" >
            <div class="card-body box-btn-parent">
              <h5 class="card-title">
                <icon name="shopping-bag" class="box-icon" scale="1.5"/>
                Consumers</h5>
              <p class="card-text">Reach your best prospects using the widest selection of demographic lifestyle, and purchase behavior selection options.</p>
              <div class="box-btn-box box-btn-box-high">
                <b-btn  @click="go(10)" class="btn btn-outline-primary" data-test="landing-datasource-10">
                  Start here<icon name="caret-right" class="icon-right"/></b-btn>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body box-btn-parent">
              <h5 class="card-title">
                <icon :name="secondDatasource.icon" class="box-icon" scale="1.5" v-if="secondDatasource.icon"/>
                {{secondDatasource.title}}
              </h5>
              <p class="card-text">{{secondDatasource.brief || 'First choose a geographic area, and then refine your targeting with demographics, interests and propensities.'}}</p>
              <div class="box-btn-box box-btn-box-high">
                <b-btn  @click="go(secondDatasource.ListType)" class="btn btn-outline-primary" :data-test="'landing-datasource-' + secondDatasource.ListType">
                  Start here<icon name="caret-right" class="icon-right"/></b-btn>
              </div>
            </div>
          </div>
        </div>
        <div class="card-deck" style="margin-top: 0;display: flex; justify-content: flex-start;align-items: stretch">
          <div class="card" v-for="item in normalBtns" :key="item.ListType" :style="{'min-width': datasourceWidth}"
               style="margin-top: 16px; flex-grow: 0">
            <div class="card-body box-btn-parent">
              <h5 class="card-title">
                <icon :name="item.icon" class="box-icon" scale="1.5"/>
                {{item.title}}
              </h5>
              <p class="card-text">{{item.brief || 'First choose a geographic area, and then refine your targeting with demographics, interests and propensities.'}}</p>
              <div class="box-btn-box box-btn-box-high">
                <b-btn  @click="go(item.ListType)"  class="btn btn-outline-primary" :data-test="'landing-datasource-' + item.ListType">
                  Start here <icon name="caret-right" class="icon-right"/></b-btn>
              </div>
            </div>
          </div>

        </div>
        <hr class="my-4">
        <h3>Begin a digital campaign</h3>
        <p>Tell us your goals and budget. Our experts will craft and manage a full-service campaign for you.</p>
        <div class="card-deck">
          <div class="card">
            <div class="card-body box-btn-parent">
              <h5 class="card-title"><icon name="at" class="box-icon" scale="1.5" /> Choose email</h5>
              <p class="card-text">Reach new prospects more effectively via email with help from our digital experts, who manage campaigns for some of the nation's leading brands.</p>
              <div class="box-btn-box box-btn-box-high">
                <b-btn @click="showDigital" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></b-btn>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body box-btn-parent-sm">
              <h5 class="card-title"><icon name="desktop" class="box-icon" scale="1.5" style="margin-right: 4px"/>Choose display &amp; social</h5>
              <p class="card-text">Deploy campaigns to the devices and networks people check every day. Our team will help you make a good first (and following) impression.</p>
              <div class="box-btn-box box-btn-box-high">
                <b-btn @click="showDigital" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></b-btn>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body box-btn-parent-sm">
              <h5 class="card-title"><icon name="share-alt" class="box-icon" scale="1.5" /> Choose multi-channel</h5>
              <p class="card-text">Multi-channel marketing increases your visibility and reinforces your messaging. Trust our digital experts to build a mix that's right for you.</p>
              <div class="box-btn-box box-btn-box-high">
                <b-btn @click="showDigital" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></b-btn>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="jumbotron" v-if="userServiceDataSources.showEnhanceList||userServiceDataSources.showEmailAppend||userServiceDataSources.showPhoneAppend||userServiceDataSources.showPhoneReverse||userServiceDataSources.showEmailReverse||userServiceDataSources.showCleanList||userServiceDataSources.showEmailVerification||userServiceDataSources.showPhoneVerification">
        <h2 class="display-4" id="service">Manage your customer data</h2>
        <p class="lead">Improve and enrich the information in your customer database. Simply choose a service and load your file. Go refill your coffee and your updated file may already be waiting for you!</p>
        <hr class="my-4">
        <div v-if="userServiceDataSources.showEnhanceList||userServiceDataSources.showEmailAppend||userServiceDataSources.showPhoneAppend||userServiceDataSources.showPhoneReverse||userServiceDataSources.showEmailReverse">
          <h3>Enhance your data</h3>
          <p>Append our data to your current book of business so you can segment and target customers better. Send more relevant messaging and offers, for better ROI.</p>
          <div class="card-deck">
            <div class="card" v-if="userServiceDataSources.showEnhanceList">
              <div class="card-body box-btn-parent">
                <h5 class="card-title"><icon name="adn" class="box-icon" scale="1.5" /> Append demographics or psychographics</h5>
                <p class="card-text">Add demographic and interest data to your customer database for more personalized communications.</p>
                <div class="box-btn-box">
                  <a :href="$store.getters['config/link']('enhanceList')" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></a>
                </div>
              </div>
            </div>
            <div class="card" v-if="userServiceDataSources.showEmailAppend">
              <div class="card-body box-btn-parent">
                <h5 class="card-title"><icon name="envelope" class="box-icon" scale="1.5" /> Append email addresses</h5>
                <p class="card-text">Match privacy-compliant email addresses to your customers so you can contact them through this low-cost service.</p>
                <div class="box-btn-box">
                  <a :href="$store.getters['config/link']('emailAppend')" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></a>
                </div>
              </div>
            </div>
          </div>
          <div class="card-deck" style="margin-top: 2.0rem;">
            <div class="card" v-if="userServiceDataSources.showPhoneAppend">
              <div class="card-body box-btn-parent">
                <h5 class="card-title"><icon name="phone" class="box-icon" scale="1.5" /> Append phone numbers</h5>
                <p class="card-text">Add phone numbers to your customer data for direct sales or for follow-up on a campaign sent via another channel.</p>
                <div class="box-btn-box">
                  <a :href="$store.getters['config/link']('phoneAppend')" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></a>
                </div>
              </div>
            </div>
            <div class="card" v-if="userServiceDataSources.showPhoneReverse">
              <div class="card-body box-btn-parent">
                <h5 class="card-title"><icon name="phone" class="box-icon" scale="1.5" /> Reverse-phone append</h5>
                <p class="card-text">Missed calls? Give us a list of phone numbers and we'll return a list of who called so you can reach them via direct mail.</p>
                <div class="box-btn-box">
                  <a :href="$store.getters['config/link']('phoneReverse')" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></a>
                </div>
              </div>
            </div>
            <div class="card" v-if="userServiceDataSources.showEmailReverse">
              <div class="card-body box-btn-parent">
                <h5 class="card-title"><icon name="envelope" class="box-icon" scale="1.5" /> Reverse email append</h5>
                <p class="card-text">For each record where a customer may only have a email address for an individual, we append the individual’s name and postal address where available</p>
                <div class="box-btn-box">
                  <a :href="$store.getters['config/link']('reverseEmailAppend')" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="userServiceDataSources.showCleanList||userServiceDataSources.showEmailVerification||userServiceDataSources.showPhoneVerification">
          <hr class="my-4">
          <h3>Clean &amp; verify your data</h3>
          <p>De-duplicate records, correct undeliverable addresses and screen for privacy... all to save you time and money.</p>
          <div class="card-deck">
            <div class="card" v-if="userServiceDataSources.showCleanList">
              <div class="card-body box-btn-parent">
                <h5 class="card-title"><icon name="magic" class="box-icon" scale="1.5" /> Clean your database</h5>
                <p class="card-text">Save money by removing duplicate and undeliverable customer records. Update change of address to make sure your mail gets to your buyers.</p>
                <div class="box-btn-box">
                  <a :href="$store.getters['config/link']('cleanList')" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></a>
                </div>
              </div>
            </div>
            <div class="card" v-if="userServiceDataSources.showEmailVerification">
              <div class="card-body">
                <h5 class="card-title"><icon name="envelope-square" class="box-icon" scale="1.5" /> Verify email addresses</h5>
                <p class="card-text">Keep your email deliverability score high and save money by avoiding outdated or invalid email addresses.</p>
                <div class="box-btn-box">
                  <a :href="$store.getters['config/link']('emailVerification')" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></a>
                </div>
              </div>
            </div>
            <div class="card" v-if="userServiceDataSources.showPhoneVerification">
              <div class="card-body">
                <h5 class="card-title"><icon name="phone-square" class="box-icon" scale="1.5" /> Verify phone numbers</h5>
                <p class="card-text">Save time and money otherwise wasted on calling bad numbers, improving your connection rate and communications efficiency.</p>
                <div class="box-btn-box">
                  <a :href="$store.getters['config/link']('phoneVerification')" class="btn btn-outline-primary">Start here <icon name="caret-right" class="icon-right"/></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="jumbotron" v-if="userServiceDataSources.showPortraitReports">
        <h2 class="display-4" id="analyze">Analyze your customer data</h2>
        <p class="lead">Gain insight into the demographic and psychographic characteristics of your customers, and identify prospects likely to become new customers.</p>
        <hr class="my-4">
        <h3>View sample reports</h3>
        <p>Learn about each report before you begin.</p>
        <div class="card-deck">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Look-Alike Report &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h5>
              <p class="card-text">This report includes a demographic portrait of your file plus a calculated Market Penetration Index ("MPI") which enables you to define the prospective market potential. The higher the index calculation, the greater success you had.</p>
            </div>
            <div class="card-footer">
              <a :href="$store.getters['config/link']('reportLookALike')" class="btn btn-outline-secondary">Preview <icon name="caret-right" class="icon-right"/></a></div>
          </div>
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Enhanced Look-Alike Report</h5>
              <p class="card-text">This report helps you take a broad view of your customer base, identify where you have a strong or weak market presence, learn who your best customers are and how they are different from the rest, and more!</p>
            </div>
            <div class="card-footer">
              <a :href="$store.getters['config/link']('reportEnhanceLookAlike')" class="btn btn-outline-secondary">Preview <icon name="caret-right" class="icon-right"/></a></div>
          </div>
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">PersonicX Portrait Report</h5>
              <p class="card-text">This report  enables you to better understand who your best customers are using segmentation. It includes an index that enables you to define the prospective market potential.</p>
            </div>
            <div class="card-footer">
              <a :href="$store.getters['config/link']('reportPortrait')" class="btn btn-outline-secondary">Preview <icon name="caret-right" class="icon-right"/></a></div>
          </div>
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Data Portrait Analysis &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h5>
              <p class="card-text">This report compares the demographic and lifestyle/interest characteristics of customer households to the characteristics of households in your local or regional geographic area.</p>
            </div>
            <div class="card-footer">
              <a :href="$store.getters['config/link']('reportPortraitRegional')" class="btn btn-outline-secondary">Preview <icon name="caret-right" class="icon-right"/></a></div>
          </div>
        </div>
        <hr class="my-4">
        <h3>Choose a report</h3>
        <p>We offer a series of reports, starting at just $350.00. Upload your customer file and choose a target area. Turnaround time varies from one to five business days.</p>
        <a :href="$store.getters['config/link']('portaitreports')" class="btn btn-primary">Get started <icon name="caret-right" class="icon-right"/></a>
        <b-link href="#" class="btn btn-outline-primary" @click="showContactUs">Ask an expert <icon name="caret-right" class="icon-right"/></b-link>
      </div>

    </section>
  </article>
</template>

<script>
  export default {
    data () {
      return {
        firstUserName: window.first.userName,
        secondDatasource: {}
      }
    },
    computed: {
      username () {
        if (this.firstUserName) {
          return this.firstUserName
        } else {
          return this.$store.state.site.User_FullName || ''
        }
      },
      welcomeText () {
        let text = ''
        let now = new Date().getHours()
        if (now >= 5 && now < 12) {
          text = 'Good Morning'
        } else if (now >= 12 && now < 18) {
          text = 'Good Afternoon'
        } else if (now >= 18 && now < 22) {
          text = 'Good Evening'
        } else {
          text = 'Good Night'
        }
        return text + ', '
      },
      userDataSources () {
        return this.$store.state.user.userDataSources
      },
      userServiceDataSources () {
        return this.$store.state.user.userServiceDataSources
      },
      normalBtns () {
        let result = []
        let isSaturation = false
        let hasBusiness = false
        for (let i = 0; i < this.userDataSources.length; i++) {
          let item = this.userDataSources[i]
          if (item.ListType === 170) {
            hasBusiness = true
            this.secondDatasource = item
          }
          if (item.ListType === 50) {
            isSaturation = true
          } else if (item.ListType !== 10 && item.ListType !== 170) {
            result.push(item)
          }
        }
        if (isSaturation) {
          for (let i = 0; i < this.userDataSources.length; i++) {
            let item = this.userDataSources[i]
            if (item.ListType === 50) {
              item.Desc = 'Occupant/Saturation'
              result.push(item)
            }
          }
        }
        if (!hasBusiness) {
          this.secondDatasource = result[0]
          result.shift()
        }
        if (!this.secondDatasource) {
          this.secondDatasource = {}
        }
        return result
      },
      datasourceWidth () {
        let num = this.normalBtns.length
        if (num === 1) {
          return 'calc(100% - 32px)'
        } else if (num === 2) {
          return 'calc(50% - 32px)'
        } else if (num === 3 || num === 5 || num === 6 || num === 9 || num === 12) {
          return 'calc(33.33% - 32px)'
        } else {
          return 'calc(25% - 32px)'
        }
      },
      blockClass: {
        get: function () {
          if (this.$store.state.user.ShowVideos) {
            return 'col-sm-12 col-md-3'
          } else {
            return 'col-sm-12 col-md-4'
          }
        }
      },
      videoVisibleFlag: function () {
        if (this.$store.state.user.ShowVideos) {
          return 'margin-bottom: 16px'
        } else {
          return 'margin-bottom: 16px;display: none'
        }
      }
    },
    methods: {
      go (listType) {
        this.$router.push({
          name: 'order',
          params: {
            listType: listType
          }
        })
      },
      gotoVideo () {
        this.$router.push({
          name: 'videos'
        })
      },
      showDigital () {
        this.$root.$emit('bv::show::modal', 'modelDigitalCampaigns')
      },
      showContactUs () {
        this.$root.$emit('bv::show::modal', 'modalContactUs')
      }
    }
  }
</script>

<style scoped lang="scss">
  body { font-family: 'Roboto', Helvetica, Arial, sans-serif; }
  header { }
  footer { background-color: #404040; border-top: 3px solid #808080; padding: 2.0rem 0 2.0rem 0; color: #A0A0A0; }
  footer a { color: #A0A0A0 !important; }
  footer a:hover { color: #FFF !important; }
  a span.bullet { display: inline-block; width: 1.75rem; text-align: left; }
  .hero { background-image: url('../../assets/images/landBack_new.jpg'); background-position: center; background-size: cover; border-top: 3px solid #808080; border-bottom: 3px solid #808080; }
  .hero h1 { margin: 2.0rem 0 0 0; padding: 0.5rem; font-size: 4.0rem; font-weight: 100; color: #FFF;  }
  .hero h2 { margin: 0 0 5.0rem 0; padding: 0 0.5rem 0.5rem 0.5rem; font-weight: 100; color: #FFF; }
  .card-deck:nth-child(2) { margin-top: 2.0rem !important; padding: 0 !important; }
  .card h4, .card h5 { color: #e04557; }
  .card a.btn { width: 50%; margin: 1.0rem auto; display: block; clear: both; min-width: 100px; padding: 5px 0 !important;}
  /* Override "stock" Bootstrap styles for special cases */
  article { padding: 0 !important; }
  .dropdown-menu h6 { padding: 0.25rem 1.0rem; font-weight: bold; color: #e04557; }
  .dropdown-menu p { margin-bottom: 0.5rem; padding: 0 1.0rem; font-size: smaller; color: #808080; }
  .dropdown-menu a { padding: 0.25rem 1.0rem; font-size: smaller; color: #808080; }
  .dropdown-menu form { padding: 0 1.0rem; }
  .dropdown-menu button { margin: 0.25rem 1.0rem; font-size: smaller; }
  .jumbotron:first-of-type { margin-top: 2.0rem; }
  .btn-primary { background-color: #e04557; border-color: #e04557; }
  .btn-primary:hover { background-color: #e04557; }
  .btn-outline-primary { border-color: #e04557; color: #e04557; }
  .btn-outline-primary:hover { background-color: #e04557; color: #FFFFFF;border-color: #e04557; }
  .btn-outline-primary:not([disabled]):active {
    color:$color-white;
    background-color: $color-text-grey !important;
    border-color: $color-text-grey !important;
    box-shadow: none;
  }
  h2 {
    color: inherit;
    margin-bottom: .5em;
    margin-top: 0;
    --font-family-sans-serif: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
    --font-family-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
  }
  h3 {
    font-size: 1.75rem;
    margin-bottom: .5rem;
    font-family: inherit;
    line-height: 1.2;
    color: #212529;
    font-weight: 300;
  }
  h4 {
    font-size: 1.5rem;
  }
  .h5, h5 {
    font-size: 1.25rem;
  }
  p {
    color: #212529;
  }
  .jumbotron{
    background-color:#e9ecef ;
  }
  #landing-top {
    background-color: #fff;
  }
  .card-img-top {
    width: 100%;
    text-align: center;
  }
  .card {
    padding: 0 !important;
    margin-bottom: 8px;
    /*border: 0 !important;*/
  }
  .banner-card-block {
    border: 2px solid $color-primary;
    text-align: center;
    height: 100%;
  }
  .box-btn-box{
    text-align: center;
    position: absolute;
    bottom: 8px;
    width:100%;
    margin-left: -1.25em;
  }
  .box-btn-parent {
    padding-bottom: 64px;
  }
  .box-btn-box-high {
    bottom: 16px;
  }
  .box-icon {
    font-weight: 900;
    font-family: Font Awesome\ 5 Free;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
  }
  .icon-right {
    margin-left: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/landings/MV4.vue